var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVectorB(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 132,
    height: 132,
    rx: 30,
    fill: "#47B638"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.4995 36C49.2344 36 36 49.2338 36 65.5C36 81.7655 49.2342 95 65.4995 95C81.7666 95 95 81.7655 95 65.5C95 49.2338 81.7666 36 65.4995 36ZM83.5052 75.2638C83.0838 75.6843 82.5318 75.8966 81.98 75.8966C81.4272 75.8966 80.8753 75.6843 80.4538 75.2638L65.4995 60.3116L50.5467 75.2638C49.7037 76.1066 48.3357 76.1066 47.4927 75.2638C46.6492 74.4211 46.6492 73.0546 47.4927 72.2117L63.9733 55.7342C64.8173 54.8915 66.1811 54.8915 67.0236 55.7342L83.5041 72.2117C84.3482 73.0546 84.3482 74.4211 83.5052 75.2638Z",
    fill: "#47B638"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorB);
export default __webpack_public_path__ + "static/media/VectorB.eee52caeb39520c83cf06f9654d38a45.svg";
export { ForwardRef as ReactComponent };